/* import __COLOCATED_TEMPLATE__ from './config-button.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();